import React, { Component } from 'react';
//components

//styles
import './scss/carusel.scss';
import '../../Static/fonts/impact/stylesheet.css'
import '../../Static/fonts/NarkisBlockCondensed/style.css'


const Circles = (props) => {
    let circle = [];
    let year = 1948;
    let transform = "rotate3d(0, 0, 1," + props.transformDegree + "deg)";
    let transformStyle = {
        'transform': transform,
        'WebkitTransform': transform,
        'MozTransform': transform,
        'msTransform': transform,
        'OTransform': transform
    };


    for (let i = 0; i < 7; i++) {
        let plusYears = i==6 ? 10 : 9;
        circle.push(<div className="circle" key={i}><div className={i === props.selectedValue ? "inner selected" : "inner"} onClick={ () => i === props.selectedValue ? props.goToDecade() : props.setSelected(i)}>{(year + plusYears) + "-" + year}</div></div>)
        year += 10;
    }
    return (
        <div className="circle-items" style={transformStyle}>
            {circle}
        </div>
    )
}

class Carusel extends Component {
    state = {
        selectedValue: 0,
        transformDegree: 270,
        selectedDegree: 270,
        isRight: false,
        titleAnimation: false
    }

    setSelected = (selectedValue) => {
        let degree = this.getDegree(selectedValue, this.state.isRight);
        this.setState(prevState => ({
            selectedValue,
            transformDegree: degree,
            selectedDegree: degree,
            titleAnimation: true
        }))
    }

    goToDecade = () => {
        this.props.sendGA("Timeline_Clicked", (this.state.selectedValue + 1));
        let url =`#/decade/${this.state.selectedValue + 1}`;
        this.props.vPush(this.props.decadesJSON[this.state.selectedValue].title, url);
        window.location.href = `./#/decade/${this.state.selectedValue + 1}`;
    }

    handleTouchMove = (t) => {
        let x = t.targetTouches[0].clientX;
        let middle = window.innerWidth / 2;
        let swipe = 0;
        let isRight = false;
        if (x > middle) {
            isRight = true;
            swipe = x - middle;
        }
        else {
            isRight = false;
            swipe = middle - x;
        }
        this.setState(prevState => ({
            transformDegree: isRight ? this.state.selectedDegree + swipe : this.state.selectedDegree - swipe,
            isRight: isRight
        }))
    }

    handleTouchEnd = (t) => {
        let deg = this.getJump();
        let index = 0;
        if (this.state.transformDegree > this.state.selectedDegree) // left
            index = this.state.selectedValue - deg
        else // right
            index = this.state.selectedValue + deg
        if (deg > 0) 
            this.setSelected(this.getIndex(index));
        else 
            this.setSelected(this.state.selectedValue);
    }

    getJump = () => {
        return Math.round(Math.abs(this.state.selectedDegree - this.state.transformDegree) / (360 / 7));
    }

    getDegree = (selected, isRight) => {
        let jump = this.getJump();
        if (jump === 0) 
            return 270 - ((360 / 7) * selected)
        return isRight ? this.state.selectedDegree + ((360 / 7) * jump) : this.state.selectedDegree - ((360 / 7) * jump);
    }

    getIndex = (index) => {
        if (index < 0) 
            return 7 - Math.abs(index)
        else if (index > 6)
            return index - 7;
        return index;
    }

    render() {
        return (
            <div className="carusel-container">
                <div className="wheel"
                    onTouchMove={touchMoveEvent => this.handleTouchMove(touchMoveEvent)}
                    onTouchEnd={this.handleTouchEnd}>
                    <div className="title-container"><div className={this.state.titleAnimation ? "title animation" : "title"} onClick={this.goToDecade}>צאו למסע בזמן</div></div>
                    <div className="circle-container">
                        <Circles
                            selectedValue={this.state.selectedValue}
                            setSelected={this.setSelected}
                            transformDegree={this.state.transformDegree}
                            goToDecade={this.goToDecade}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Carusel;



// WEBPACK FOOTER //
// ./src/Components/Carusel/Carusel.js